module.exports = __webpack_public_path__ + "static/media/typ@2x.d161a67f.png";